import { keysToSnake } from '#/api/adapters/wireCase';
import { toCreateSalesOrderBody } from '#/api/crmMgmt/customerOrder/serialize';

/**
 * 銷貨單 update payload（camel → snake）。
 * 僅 DRAFT；含 updatedAt（＝ record.updatedAt）。
 */
export function serializeSalesOrderUpdate(values) {
  return keysToSnake(values);
}

/**
 * 獨立建立（無客訂）full DRAFT＋`customer_id`。
 * **pending backend**：route／欄位以後端定稿為準。
 */
export function toCreateSalesOrderStandaloneBody(values = {}) {
  return {
    ...toCreateSalesOrderBody(values),
    customerId: values.customerId ?? values.customer?.id ?? null,
    currencyId: values.currencyId || null,
  };
}

/** POST `/crm/sales-order` */
export function serializeSalesOrderCreate(values) {
  return keysToSnake(toCreateSalesOrderStandaloneBody(values));
}
